"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemIcon = ItemIcon;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
var react_2 = require("react");
var toIconifyName_1 = require("../../../../../helpers/icons/toIconifyName");
var item_1 = require("../../../../../reducers/slices/item/item");
var constants_1 = require("../constants");
var sizeClasses = {
    sm: { frame: "w-8 h-8", glyph: 16 },
    md: { frame: "w-12 h-12", glyph: 20 },
    lg: { frame: "w-16 h-16", glyph: 30 },
    xl: { frame: "w-24 h-24", glyph: 48 },
};
function ItemIcon(_a) {
    var _b, _c, _d, _e, _f, _g;
    var item = _a.item, file_url = _a.file_url, _h = _a.size, size = _h === void 0 ? "md" : _h;
    var _j = (0, react_2.useState)(), failedUrl = _j[0], setFailedUrl = _j[1];
    var _k = sizeClasses[size], frame = _k.frame, glyph = _k.glyph;
    var backgroundColor = ((_c = (_b = item.badge) === null || _b === void 0 ? void 0 : _b.theme) === null || _c === void 0 ? void 0 : _c.primary) || item_1.defaultBadgeSettings.theme.primary;
    var iconColor = ((_e = (_d = item.badge) === null || _d === void 0 ? void 0 : _d.theme) === null || _e === void 0 ? void 0 : _e.icon) || item_1.defaultBadgeSettings.theme.icon;
    var imageUrl = file_url || ((_f = item.icon) === null || _f === void 0 ? void 0 : _f.url);
    var showImage = Boolean(imageUrl) && imageUrl !== failedUrl;
    return ((0, jsx_runtime_1.jsx)("div", { className: "".concat(frame, " shrink-0 rounded-full flex items-center justify-center overflow-hidden"), style: { backgroundColor: backgroundColor }, children: showImage ? ((0, jsx_runtime_1.jsx)("img", { src: imageUrl, alt: "", className: "w-full h-full object-cover", onError: function () { return setFailedUrl(imageUrl); } })) : ((0, jsx_runtime_1.jsx)(react_1.Icon, { icon: ((_g = item.icon) === null || _g === void 0 ? void 0 : _g.name) ? (0, toIconifyName_1.toIconifyName)(item.icon) : (0, constants_1.itemTypeIcon)(item.type), width: glyph, style: { color: iconColor } })) }));
}
